<div class="dialog-header">
    <h6>{{isEditMode ? 'Edit Vessel Field' : 'Multiple Vessel Creation'}}</h6>
    <button mat-icon-button class="close-icon" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content">
    <form [formGroup]="vesselCreationForm">
        <div class="topbar">
            <div></div>
            <button *ngIf="!isEditMode" mat-raised-button color="primary" class="add-button" (click)="addVesselRow()">
                Add Field
            </button>
        </div>

        <div class="table-container" formArrayName="vessels">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 compact-table">
                <ng-container matColumnDef="sno">
                    <th mat-header-cell *matHeaderCellDef class="sno-column">No</th>
                    <td mat-cell *matCellDef="let element" [formGroupName]="element.index" class="sno-column">
                        {{element.index + 1}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="field_name">
                    <th mat-header-cell *matHeaderCellDef class="field-column">Field Name</th>
                    <td mat-cell *matCellDef="let element" [formGroupName]="element.index" class="field-column">
                        <mat-form-field appearance="outline" class="compact-field">
                            <input matInput formControlName="field_name" />
                            <mat-error
                                *ngIf="element.control.get('field_name')?.hasError('required') && element.control.get('field_name')?.touched">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="data_type">
                    <th mat-header-cell *matHeaderCellDef class="type-column">Type</th>
                    <td mat-cell *matCellDef="let element" [formGroupName]="element.index" class="type-column">
                        <mat-form-field appearance="outline" class="compact-field">
                            <mat-select formControlName="data_type"
                                (selectionChange)="onDataTypeSelect($event, element)">
                                <mat-option value="string">Text</mat-option>
                                <mat-option value="number">Number</mat-option>
                                <mat-option value="date">Date</mat-option>
                                <mat-option value="select">Select</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="element.control.get('data_type')?.hasError('required') && element.control.get('data_type')?.touched">
                                Required
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field *ngIf="element.control.get('showDropDownField')?.value" appearance="outline"
                            class="compact-field">
                            <textarea rows="1" cdkTextareaAutosize #autoSize="cdkTextareaAutosize" matInput
                                formControlName="dropdown_input" placeholder="Enter value"></textarea>
                            <mat-error
                                *ngIf="element.control.get('dropdown_input')?.hasError('required') && element.control.get('dropdown_input')?.touched">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="is_mandatory">
                    <th mat-header-cell *matHeaderCellDef class="mandatory-column">Required</th>
                    <td mat-cell *matCellDef="let element" [formGroupName]="element.index" class="mandatory-column">
                        <mat-form-field appearance="outline" class="compact-field">
                            <mat-select formControlName="is_mandatory">
                                <mat-option value='Y'>Required</mat-option>
                                <mat-option value='N'>Optional</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="element.control.get('is_mandatory')?.hasError('required') && element.control.get('is_mandatory')?.touched">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="action-column">Action</th>
                    <td mat-cell *matCellDef="let element" class="action-column">
                        <button mat-icon-button class="delete-btn" type="button" *ngIf="vesselsArray.length > 1"
                            (click)="removeVesselRow(element.index)">
                            <mat-icon class="delete-icon">delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </form>
</div>

<div class="dialog-footer">
    <button mat-raised-button color="primary" class="save-button" (click)="saveVessels()">
        {{isEditMode ? 'Update' : 'Save'}} Vessels
    </button>
</div>